import { eTipoPermissao } from "@/enums/ePermissoes";

const permissions = [eTipoPermissao.MEDICAONOVO_MENU_1900400399];

export default [
 {
  description: "Medição",
  path: "/merenda/mermedicao",
  name: "mermedicao",
  component: () => import("@/views/merenda/mermedicao/Index.vue"),
  meta: {
   permissions,
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Medição",
  path: "/merenda/mermedicao/cadastro/:id?",
  parent: "mermedicao",
  name: "mermedicao_create",
  component: () => import("@/views/merenda/mermedicao/InclusaoEdicao.vue"),
  meta: {
   permissions,
  },
  goesToMenu: true,
 },
]
